export default __webpack_public_path__ + "cta-component-product-shot-mobile.png";